import { CustomLocaleData } from '@app/ui';

export const UK_CUSTOM_LOCALE_DATA: CustomLocaleData = {
  localeIdentifier: 'en-GB',
  currencyName: 'GBP',
  currencySymbol: '£',
  phoneCountry: 'gb',
  hourOnlyFormat: 'H',
  timeWithLeadingZeroFormat: 'HH:mm',
  timezone: 'Europe/London', // GMT (UTC +0 / +1 DST)
};
